import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { NotificationTemplateModel, ParameterModel } from './model';

export const notificationTemplateAdapter: EntityAdapter<NotificationTemplateModel> = createEntityAdapter<NotificationTemplateModel>({
  selectId: model => model.id,
});

export interface NotificationTemplateState extends EntityState<NotificationTemplateModel> {
  selected: NotificationTemplateModel;
  isLoading?: boolean;
  error?: any;
  parameters: ParameterModel[];
}

export const initialState: NotificationTemplateState = notificationTemplateAdapter.getInitialState({
  selected: null,
  isLoading: false,
  error: null,
  parameters: null,
});
